export default __webpack_public_path__ + "static/media/logo-pt_PT.62041d6d.svg";